import { useEffect } from "react";
import { useCancellablePromise } from "../useCancellablePromise/useCancellablePromise";

/**
 Example Usage:

// setup some data
const data = "something";

// build a function using currying
// eg updateOrgAsync(data) returns a function that has the parameters bound
const updateOrgAsync = params => () => {
  setTimeout(() => console.log(params), 30000);
};

// build the fetchtrigger using the hook and then run it
useFetchOnMount(updateOrgAsync(data));

 */

/**
 * Fetch Hook for functional Components
 *
 * @param {*} asyncFunction
 */
const useFetchOnMount = asyncFunction => {
  const { cancellablePromise } = useCancellablePromise();

  const asyncAction = async () => {
    await asyncFunction();
  };

  useEffect(() => {
    cancellablePromise(asyncAction());
  }, []);
};

export default useFetchOnMount;



// WEBPACK FOOTER //
// ./resources/assets/js/app/hooks/useFetchOnMount/useFetchOnMount.js